<template>
  <div class="contact-block" id="contact-block">
    <div class="info-title">通讯录</div>
    <div class="filter-layer">
      <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="86px" label-position="left">
        <el-form-item label="联系人类型" prop="subject">
          <el-select v-model="queryParams.subject" placeholder="请选择联系人类型" size="small">
            <el-option label="全部" value="all"></el-option>
            <el-option label="个人" value="person"></el-option>
            <el-option label="企业" value="company"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字查询" prop="condition">
          <el-input v-model="queryParams.condition" placeholder="请输入联系人姓名/手机号/备注" clearable size="small" />
        </el-form-item>


        <el-form-item style="margin-right: 16px;">
          <el-button size="small" class="grey-btn" @click="handleResetForm" :disabled="calcQueryParamsDisable()"><svg-icon
              iconClass="icon-refresh" style="width: 16px;height: 16px;" />重置</el-button>
        </el-form-item>
        <el-form-item style="margin-right: 16px;">
          <el-button type="primary" size="small" @click="handleQuery"><svg-icon iconClass="icon-search"
              style="width: 16px;height: 16px;vertical-align: middle;" />查询</el-button>
        </el-form-item>
        <el-form-item style="margin-right: 0;">
          <el-button size="small" class="grey-btn" @click="handleExport" :disabled="!contactList.length"><svg-icon
              iconClass="icon-export" style="width: 16px;height: 16px;" />导出列表</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row class="stand-layer">
      <el-button type="primary" size="small" @click="handleAdd"><svg-icon iconClass="icon-add"
          style="width: 16px;height: 16px;" />新增</el-button>
      <el-button type="primary" size="small" @click="handleImport"><svg-icon iconClass="icon-dl"
          style="width: 16px;height: 16px;" />导入</el-button>
      <el-button type="danger" size="small" @click="handlePatchDelete" :disabled="multipleSelected.length <= 0"><svg-icon
          iconClass="icon-trash" style="width: 16px;height: 16px;" />删除</el-button>
    </el-row>
    <div class="table-layer" style="padding-left: 20px;">

      <el-table ref="listTableRef" :data="contactList" @selection-change="handleSelectionChange($event)"
        :header-cell-style="{ background: '#F2F3F5', color: '#1D2129', fontWeight: 500, padding: '12px 10px' }"
        :cell-style="{
          color: '#313843',
          fontWeight: 400,
          padding: '12px 10px'
        }" height="100%">
        <el-empty description="暂无数据" slot="empty" :image="require('@/assets/images/home/default.png')" :image-size="220">
        </el-empty>
        <el-table-column type="selection" width="38">
        </el-table-column>
        <el-table-column prop="subject" label="联系人类型" width="100">
          <template slot-scope="scope">
            <div class="scope-content">
              <span>{{ scope.row.subject == "person" ? "个人" : "企业" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="scope-content" v-if="scope.row.subject == 'company'">
              <span>{{ scope.row.companyName }}</span>
            </div>
            <div class="scope-content" v-else>
              <span>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="personName" label="联系人姓名" show-overflow-tooltip width="140">
          <template slot-scope="scope">
            <div class="scope-content" v-if="scope.row.personName">
              <span>{{ scope.row.personName }}</span>
            </div>
            <div class="scope-content" v-else>
              <span>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="personAddress" label="联系方式" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="scope-content" v-if="scope.row.personAddress">
              <span>{{ scope.row.personAddress }}</span>
            </div>
            <div class="scope-content" v-else>
              <span>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime, '{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="scope-content" v-if="scope.row.remark">
              <span>{{ scope.row.remark }}</span>
            </div>
            <div class="scope-content" v-else>
              <span>无</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="toView(scope.row)">查看</el-button>
            <el-button type="text" @click="toEdit(scope.row)">修改</el-button>
            <el-button type="text" class="danger" @click="toDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pager-layer">
      <el-pagination v-if="contactList && contactList.length" :total="total" :current-page.sync="queryParams.pageNum"
        layout="sizes, total, prev, pager, next" :page-sizes="[5, 10, 20, 100]" :page-size.sync="queryParams.pageSize"
        @size-change="sizeChange" @current-change="pageChange" />
    </div>


    <el-dialog :title="contactTitle" :visible.sync="addContactOpen" width="530px" append-to-body
      :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="110px" label-position="left">
        <el-form-item label="联系人类型">
          <el-radio-group v-model="addForm.subject" @change="handleChangeSubject"
            style="height: 32px;display: flex;align-items: center;">
            <el-radio label="person">个人</el-radio>
            <el-radio label="company">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="企业名称" prop="companyName" v-if="addForm.subject === 'company'" :rules="[
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur',
            validator: checkBlankCompanyName
          }
        ]">
          <el-input v-model="addForm.companyName" placeholder="请输入企业名称" maxlength="30" size="small" />
        </el-form-item>
        <el-form-item label="经办人姓名" prop="personName" :rules="[
          {
            required: true,
            message: '请输入经办人姓名',
            trigger: 'blur',
          },
          { validator: checkChinese, trigger: 'blur' },
        ]" v-if="addForm.subject === 'person'">
          <el-input v-model="addForm.personName" placeholder="请输入经办人姓名" maxlength="30" size="small" />
        </el-form-item>
        <el-form-item label="经办人姓名" prop="personName" v-else>
          <el-input v-model="addForm.personName" placeholder="请输入经办人姓名" maxlength="30" size="small" />
        </el-form-item>
        <el-form-item label="经办人手机号" prop="personAddress" :rules="[
          {
            required: true,
            message: '请输入经办人手机号',
            trigger: 'blur',
          },
          { validator: checkPhone, trigger: 'blur' },
        ]" v-if="addForm.subject === 'person'">
          <el-input v-model="addForm.personAddress" placeholder="请输入经办人手机号" maxlength="11" size="small" />
        </el-form-item>
        <el-form-item label="经办人手机号" prop="personAddress" v-else>
          <el-input v-model="addForm.personAddress" placeholder="请输入经办人手机号" maxlength="11" size="small" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" placeholder="请输入内容" maxlength="30" show-word-limit
            size="small">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="addContactSubmitForm" size="small">确认</el-button>
        <el-button @click="cancelAddContact" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看外部联系人" :visible.sync="viewContactOpen" width="700px" append-to-body :close-on-click-modal="false">
      <el-form ref="addForm" :model="viewForm" label-width="120px">
        <el-form-item label="联系人类型：">
          <span v-if="viewForm.subject == 'person'">个人</span>
          <span v-if="viewForm.subject == 'company'">企业</span>
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName" v-if="viewForm.subject === 'company'">
          {{ viewForm.companyName ? viewForm.companyName : "-" }}
        </el-form-item>
        <el-form-item :label="viewForm.subject === 'company' ? '经办人姓名：' : '经办人姓名：'" prop="personName">
          {{ viewForm.personName ? viewForm.personName : "-" }}
        </el-form-item>
        <el-form-item :label="
          viewForm.subject === 'company' ? '经办人手机号：' : '经办人手机号：'
        " prop="personAddress">
          {{ viewForm.personAddress ? viewForm.personAddress : "-" }}
        </el-form-item>
        <el-form-item label="备注：">
          {{ viewForm.remark ? viewForm.remark : "无" }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="cancelViewContact">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入外部联系人" :visible.sync="importContactOpen" width="530px" append-to-body
      :close-on-click-modal="false">
      <div class="import-head">
        <span>示例下载：</span>
        <el-link type="primary" :href="tempLinkAddress" target="_blank">联系人导入模板.xlsx</el-link>
      </div>
      <el-form ref="importForm" :model="importForm" label-width="0" style="min-height: 240px;">
        <el-form-item style="text-align: center">
          <el-upload ref="importUpload" class="upload-demo" drag :action="importAction" :headers="headers"
            :data="uploadData" :on-remove="removeDoc" :on-success="uploadSuccess" :before-upload="beforeUpload" :limit="1"
            :auto-upload="true">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="confirmImportContact">确定上传</el-button>
        <el-button size="small" @click="cancelImportContact">取消上传</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { getContactList, addContact, updataContact, removeContact, downloadContactExcelApi, tempLinkAddress, removes } from "@/api/contact";
import { getToken } from "@/utils/auth";
import { parseTime, downloadFile } from "@/utils/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      importAction: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'api/common/v1/contact/excelContactImport',
      tempLinkAddress: tempLinkAddress,
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      uploadData: {
        useImport: "n"
      },
      loaded: false,
      contactList: [],
      dialogVisible: false,
      sealId: "",
      lastFlag: "",
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        subject: "all",
        condition: ""
      },
      total: 0,
      // page: 1,
      addContactOpen: false,
      addForm: {
        subject: "person",
        companyName: "",
        personName: "",
        personAddress: "",
        remark: "",
      },
      checkBlankCompanyName: (rule, value, callback) => {
        if (value.trim() === "") {
          callback(new Error("请输入企业名称！"));
        } else {
          callback();
        }
      },
      checkChinese: (rule, value, callback) => {
        var reg = /^[\u0391-\uFFE5]+$/;
        if (!reg.test(value)) {
          callback(new Error("只能输入中文！"));
        } else {
          callback();
        }
      },
      checkPhone: (rule, value, callback) => {
        var phoneReg = /^1[3456789]\d{9}$/;
        if (!phoneReg.test(value)) {
          callback(new Error('请输入正确手机号！'));
        } else {
          callback();
        }
      },
      // addFormRules: {
      //   subject: [
      //     {
      //       required: true,
      //       message: "请选择联系人类型",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      //   companyName: [
      //     {
      //       required: true,
      //       message: "请输入企业名称",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      //   personName: [
      //     {
      //       required: true,
      //       message: "请输入真实姓名",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      //   personAddress: [
      //     {
      //       required: true,
      //       message: "请输入经办人手机号",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      // },
      // addFormRulesCompany: {
      //   subject: [
      //     {
      //       required: true,
      //       message: "请选择联系人类型",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      //   companyName: [
      //     {
      //       required: true,
      //       message: "请输入企业名称",
      //       trigger: ["blur", "change"],
      //     },
      //   ],
      // },
      submitLoading: false,
      contactId: undefined,
      contactTitle: "新增外部联系人",
      viewContactOpen: false,
      viewForm: {},
      importContactOpen: false,
      importForm: {

      },
      uploadSucceeded: false,
      uploadedFile: null,
      multipleSelected: []
    };
  },
  computed: mapState(["companyList", "currentSpace", "userInfo"]),
  created() {
    this.getContactList();
  },
  mounted() {
    window.addEventListener("resize", this.resiezeListTableRefEventHandler, true)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resiezeListTableRefEventHandler, true)
  },
  methods: {
    resiezeListTableRefEventHandler() {
      if (this.$refs.listTableRef) {
        this.$refs.listTableRef.doLayout();
        document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.contactList.length + 1) + 'px';
        document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
        document.querySelector(".table-layer").style.height = document.getElementById("contact-block").offsetHeight - document.querySelector(".filter-layer").offsetHeight - document.querySelector(".stand-layer").offsetHeight - 60 - 16 - 60 + "px";
      }
    },
    calcQueryParamsDisable() {
      let { subject, condition } = this.queryParams;
      if (!condition
        &&
        (subject == "all" || subject == "")
      ) {
        return true;
      } else {
        return false
      }
    },
    handleResetForm() {
      this.$refs["queryForm"].resetFields();
      this.queryParams = Object.assign({}, this.queryParams, {
        pageNum: 1,
        pageSize: 10,
        subject: "all",
        condition: ""
      })
      this.handleQuery();
    },
    handlePatchDelete() {
      this.$confirm("确定要批量删除选中项吗？", "温馨提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelected.map(item => {
            return item.id;
          })
          removes({ contactIds: ids })
            .then((res) => {
              if (res.code !== 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.multipleSelected = [];
                this.getContactList();
                this.$message({
                  showClose: true,
                  message: "删除成功！",
                  type: "success",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    handleSelectionChange(val) {
      this.multipleSelected = val
    },
    // changeFile(file, fileList) {
    //   console.log(file, fileList, "changeFile")
    //   this.$refs.importUpload.submit();
    // },
    uploadSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.warning({
          message: res.message,
          showClose: true
        });
        this.$refs.importUpload.clearFiles();
      } else {
        this.msgSuccess(res.data.msg);
        this.uploadSucceeded = true;
        this.uploadedFile = file;
      }
    },
    beforeUpload(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.msgError("只允许上传10M以内的文件");
        return false
      }
      if (file.name.substr(file.name.lastIndexOf(".")) != ".xls" && file.name.substr(file.name.lastIndexOf(".")) != ".xlsx") {
        this.msgError("文件格式错误，仅支持xls、xlsx格式的文件");
        return false
      }
      return true
    },
    cancelImportContact() {
      this.$refs.importUpload.clearFiles();
      this.importContactOpen = false;
    },
    removeDoc() {
      this.uploadSucceeded = false;
      this.uploadedFile = null;
    },
    confirmImportContact() {
      if (this.uploadSucceeded) {
        // this.$refs.importUpload.submit();
        // 手动上传
        let forms = new FormData()
        forms.append('useImport', 'y')
        forms.append('file', this.uploadedFile.raw)
        axios({
          method: 'POST',
          headers: { 'content-type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + getToken() },
          data: forms,
          url: this.importAction
        }).then(res => {
          if (res.data.code == 200) {
            this.$refs.importUpload.clearFiles();
            this.importContactOpen = false;
            this.msgSuccess(res.data.data.msg);
            this.getContactList();
          } else {

          }
        }).catch(() => {
          this.$refs.importUpload.clearFiles();
        })
      } else {
        this.msgWarn("请先上传联系人表excel文件");
        // this.importContactOpen = false;
      }
    },
    toView(info) {
      this.viewForm = info;
      this.viewContactOpen = true;
    },
    cancelViewContact() {
      this.viewContactOpen = false;
    },
    handleChangeSubject(value) {
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
        this.addForm = {
          subject: value,
          companyName: "",
          personName: "",
          personAddress: "",
          remark: "",
        }
      });
    },
    getContactList() {
      let queryParams = Object.assign({}, this.queryParams, {
        subject: this.queryParams.subject == "all" ? "" : this.queryParams.subject
      })
      getContactList(queryParams)
        .then((res) => {
          this.loaded = true;
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.contactList = res.data.rowArray;
            this.total = res.data.total;

            document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.contactList.length + 1) + 'px';
            document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
            document.querySelector(".table-layer").style.height = document.getElementById("contact-block").offsetHeight - document.querySelector(".filter-layer").offsetHeight - document.querySelector(".stand-layer").offsetHeight - 60 - 16 - 60 + "px";

          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sizeChange() {
      this.handleQuery();
    },
    pageChange() {
      this.handleQuery();
    },
    handleQuery() {
      this.getContactList();
    },
    handleImport() {
      this.uploadSucceeded = false;
      this.uploadedFile = null;
      this.importContactOpen = true;
    },
    handleAdd() {
      this.contactTitle = "新增外部联系人";
      this.contactId = undefined;
      this.addForm = {
        subject: "person",
        companyName: "",
        personName: "",
        personAddress: "",
        remark: "",
      };
      this.addContactOpen = true;
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
      });
    },

    // toDownload(info) {
    //   downloadContractApi({
    //     signId: info.signId,
    //   })
    //     .then((res) => {
    //       downloadFile(res, info.taskName, "zip");
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    //   // window.location.href = process.env.VUE_APP_BASE_API+'/contract/download?contractId='+contractId
    // },
    handleExport() {
      let { subject, condition } = this.queryParams;
      downloadContactExcelApi({ subject, condition })
        .then(res => {
          downloadFile(res, "联系人列表", "xlsx");
        })
        .catch(err => {
          console.log(err);
        });
    },
    // toDownloadEvidence(info) {
    // 	downloadContractEvidenceApi(info.contractId)
    // 		.then(res => {
    // 			downloadFile(res, info.taskName + "_签署报告", "pdf");
    // 		})
    // 		.catch(err => {
    // 			console.log(err);
    // 		});
    // 	// window.location.href = process.env.VUE_APP_BASE_API+'/contract/download?contractId='+contractId
    // },

    addContactSubmitForm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let method = this.contactId ? updataContact : addContact;
          let { companyName, personAddress, personName, remark, subject } = Object.assign({}, this.addForm, {});
          let param = { companyName, personAddress, personName, remark, subject };
          if (this.contactId) {
            param.contactId = this.contactId;
          }
          method(param)
            .then((res) => {
              if (res.code !== 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.getContactList();
                this.addContactOpen = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    cancelAddContact() {
      this.addContactOpen = false;
    },
    toEdit(info) {
      this.contactTitle = "修改外部联系人";
      this.addContactOpen = true;
      this.contactId = info.id;
      this.$nextTick(() => {
        this.$refs.addForm.resetFields();
        this.addForm = JSON.parse(JSON.stringify(info));
      });
    },
    toDelete(info) {
      this.$confirm("确定要删除吗？", "温馨提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeContact({ contactId: info.id })
            .then((res) => {
              if (res.code !== 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.getContactList();
                this.$message({
                  showClose: true,
                  message: "删除成功！",
                  type: "success",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
/* #user-contact-layer {
  background: #fff;
}

#user-contact-layer .el-table th>.cell {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
}

#user-contact-layer .el-table .cell {
  font-size: 14px;
  color: #666666 !important;
  position: relative;
} */

.text-btn {
  color: #666666 !important;
}

.text-btn:hover {
  color: #4489ee !important;
}

/* .filter-layer .el-form .el-form-item {
  margin-bottom: 0;
} */
</style>
<style lang="scss" scoped>
.el-submenu.is-active .el-submenu__title {
  border-left: 3px solid #3296fa;
}

.scope-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// .filter-layer {
//   // height: 100px;
//   padding-left: 22px;
//   padding-top: 30px;
//   // margin-bottom: 20px;
// }
.import-head {
  display: flex;
  align-items: center;
  margin-bottom: 64px;
}
</style>

<style lang="scss" scoped>
.contact-block {
  position: relative;
  height: 100%;
}

.info-title {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  font-weight: 500;
  color: #1D2129;
  border-bottom: 1px solid #F2F3F5;
  padding-left: 22px;
}

.stand-layer {
  padding: 12px 20px 0;

  .el-button {
    margin-right: 16px;
    margin-bottom: 16px;

    &+.el-button {
      margin-left: 0;
    }
  }

  .el-button /deep/ span {
    display: flex;
    align-items: center;

    .svg-icon {
      margin-right: 7px;
    }
  }
}

.el-table {
  min-height: 360px;
}

.filter-layer {
  padding: 16px 0 0 20px;

  .el-button /deep/ span {
    display: flex;
    align-items: center;

    .svg-icon {
      margin-right: 7px;
    }
  }
}

.pager-layer {
  width: 100%;
  height: 60px;
  padding-right: 20px;
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  z-index: 99;
}

.el-form-item {
  // margin-right: 24px;
  // margin-bottom: 16px;
  // height: 32px;
  // line-height: 32px;

  // /deep/ .el-form-item__label {
  //   font-size: 14px;
  //   font-weight: 400;
  //   color: #4E5969;
  // }

  // &+.el-form-item {
  //     // margin-left: 24px;


  // }

  // .el-button {
  //   min-width: 84px;
  // }
}

.el-input {
  // height: 32px;
  // line-height: 32px;

  /deep/ .el-input__inner {
    width: 240px;
  }
}

.el-select {
  /deep/ .el-input__inner {
    width: 212px;
  }
}

.table-layer {
  margin-top: 16px;
  height: auto;
  padding-right: 20px;

  .top-btn {
    display: block;
    width: 60px;
    height: 60px;
    background: url(../../assets/icons/png/icon-top.png) center no-repeat;
    background-size: 100%;
    // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
    // border: 1px solid rgba(220, 220, 220, 0.5);
    position: absolute;
    right: 40px;
    bottom: 68px;
    z-index: 999;
    color: #93A4BC;
    padding: 0;
    cursor: pointer;
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin-right: 8px;
  }

  /deep/ .selection-column .cell {
    padding-left: 12px !important;
  }

}

.el-table {
  width: 100%;

  /deep/ .el-table__row td:nth-last-of-type(1) .cell,
  /deep/ thead th:nth-last-of-type(1) .cell {
    padding-left: 14px !important;
  }

  /deep/ .cell {
    padding-left: 14px !important;
    padding-right: 10px !important;
    // padding: 0 !important;
  }

  /deep/ .el-table__cell {
    height: 46px;
    padding: 0 !important;
  }

  /deep/ .el-table__fixed,
  /deep/ .el-table__fixed-right {
    // box-shadow: -2px 0px 2px 0px rgba(0, 0, 0, 0.1);
    box-shadow: none;
    height: 0;
  }

  /deep/ .el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right {
    box-shadow: none;
  }

  .el-button--text {
    font-size: 14px;
    font-weight: 400;
    color: #165DFF;
    padding: 0;

    &.grey {
      color: #86909C;
    }

    &:hover {
      opacity: .7;
    }

    &.danger {
      color: #EC5B56;
    }

  }

  .el-button+.el-button {
    margin-left: 11px;
  }
}

.el-dialog .el-form-item__content {
  line-height: 32px;
}
</style>